import { Box } from '@bechtel/gds';
import styled from 'styled-components';
export const ContentStyled = styled(Box)`
  background-color: ${({ theme }) => theme.colors.grey[200]};
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  margin-top: calc(${({ theme }) => theme.spacings[100]});
  height: calc(100vh - 55px);
`;
